export default {
    category: {
        placeholder: '輸入關鍵字 ，如',
        edit: '編輯',
        delete: '刪除',
        noResult: '搜尋無結果',
        noCategory: '指令走丟了',
        changeKey: '換個關鍵字試試',
        changeKeyCategory: '前往推薦中心',
        deleteTitle: '溫馨提示',
        deleteContent: '您確定要刪除該指令嗎？ ',
        deleteConfirm: '確定',
        deleteCancel: '取消',
        deleteSuccess: '刪除成功',
        add: '創建指令',
        name: '指令',
        noSearch:"您还没有创建过智能体，点击按钮快速创建",
        noSearch1:"您還沒有創建過智能體，請去PC端創建",
        editName:"重命名對話",
        info:'對話記錄移動到這裏啦~',
        info1:"我知道了",
        info2:'已保存修改',
        info3:'已刪除',
        editName1:'重命名作品',
        deepThink:'深度思考',
        tip:'解決推理問題',
        tipHead:'深度思考已上線',
        tipMes:'擅長深度思考解決推理類問題',
        infoToast:'深度思考不支持上傳文件',
        infoToast1:'繼續切換已上傳文件將被刪除',



    },
    center: {
        placeHolder: '請輸入您的問題，Enter發送，Shift Enter換行',
        continueText:'答案過長，是否',
        continueButton:'繼續生成',
        chatLog: '記錄',
        chatDia: '對話',
        chatProduction: '作品',
        hello: '您好，我是雅意·YaYi',
        answer: '你可以對我說：',
        change: '換一批',
        stop: '停止生成',
        reopen: '即將為你開啟全新對話，一起探索新主題',
        deepThinkOpen:'本次推理已結束,即將為你打開全新對話',
        sensitiveTitle: '系統偵測到您觸發了安全審核機制，將自動為您建立新的會話',
        reference: '內容為AI生成僅供參考',
        role: '智能體',
        YaYi: '雅意',
        detail: '詳情',
        callPlugin: '呼叫插件',
        pluginTime: '插件耗時',
        pluginResult: '插件結果',
        edit: '編輯',
        copy: '複製',
        share: '分享',
        alreadyCopy: '已複製',
        regenerate: '重新生成',
        tip: '内容均由人工智能模型建置，唔代表我哋嘅心情或者观点，请仔细甄别',
        submit: '提交',
        up: '讚',
        down: '踩',
        alreadyDown: '已踩',
        example: '範例程式碼',
        play: '播放',
        alsoAsk: '你還可以問：',
        changeQuestion: '換換',
        copyCode: '複製程式碼',
        clickUpSuccess: '按讚成功',
        clickDownSuccess: '點踩成功',
        reportSuccess: '已提交舉報，感謝您的反饋',
        copySuccess: '複製成功',
        cannotUp: '目前回答無法按讚',
        cannotDown: '目前回答無法點踩',
        generateAnswer: '{name}正在為您生成答案...',
        generateAnswerHK: 'D2 正在為您生成答案...',
        themeChange: '主題切換',
        source: '來源',
        refer:'參考',
        startConnection: '建立連線中',
        endConnection: '關閉連線中',
        startRecord: '開始錄音',
        recording: '錄音中',
        assistantPlaceholder: '“/”喚醒指令助手，您也可以直接貼上連結試試',
        assistantPlaceholder1: '發送消息給{name}，Enter發送，Shift+Enter換行',
        textPlaceHolder: '有什麼問題儘管問我',
        selectedContent: '已選取內容：',
        unfold: '展開',
        doWhat: '要對這句話做點什麼呢？ ',
        uploadFinish: '上傳完成',
        pluginTip:'暫無挿件',
        confirmParse: '確認解析',
        pageReadAnalyse: '網頁閱讀分析',
        // pageReadAnalyseTip: '根據網頁精準解析回答，不超過128k',
        pageReadAnalyseTip: '根據網頁精準解析回答，不超過20萬字',
        pageReadPlaceholder: '請輸入URL',
        imgAnalyse: '影像智慧解析',
        imgTip: '支援jpg、jpeg、png圖片',
        docReadAnalyse: '文檔閱讀分析',
        // docReadAnalyseTip: '支援解析doc、docx、pdf、txt文件，不超過128k',
        docReadAnalyseTip: '支援解析doc、docx、pdf、txt文件，不超過20萬字',
        parseError: '解析失敗：內容過長',
        allowFileType: '只允許上傳檔案的格式：',
        fileSizeMoreThan10: '文件：{name}超出了20M，請處理後再上傳',
        promptCheck: 'Prompt查看',
        addConversation: '新建對話',
        tryExample: '可以試試以下案例',
        just: '剛剛',
        seconds: '秒',
        minutes: '分',
        hours: '小時',
        days: '天',
        ago: '前',
        ready: '正在搜尋網絡資料...',
        running: '正在閱讀網絡資料...',
        pageSummary:'讀取網頁並總結',
        pageKBSummary:'讀取知識檔案並總結',
        bingSearch: '連網查詢：',
        fileSearch:'知識查詢：',
        onLineSearchTitle: '查詢{name}次，共檢索到{num}個相關文件，點擊查看詳情',
        toastTitle:'當前暫不支持同時上傳圖片和文檔',
        toastTitle1:'暫不支持上傳圖片並添加網頁',
        toastContent:"如继续上传图片将覆盖已上传文件",
        toastContent1:"如繼續上傳圖片將覆蓋已上傳文件",
        okText:"覆蓋並上傳",
        about:'約{num}字',
        repeatInfo:'{url}重復,請刪除重復的URL',
        existInfo:'{url}已解析,請重新輸入',
        info:'最多解析數量為10條',
        info1:"文件數量不能超過10個",
        fileValueInfo:'鏈接地址不能為空',
        wordsLimit:'字數超出限製,請刪減後再發送',
        sendMessage:'請輸入問題後再發送',
        errMessage:'存在解析異常文件，請處理後再發送',
        failMessage:'解析失敗',
        failMessage1:'涉及敏感',
        failMessage2:'上傳失敗',
        loadingStatus:'正在聯網檢索中',
        name:'子問題{num}：',
        allSelect:"全選",
        preview:'預覽',
        shareChat:'分享對話',
        chat:'立即對話',
        copyUrl:"復製分享鏈接",
        copySuccess1:'已復製鏈接，快去分享吧~',
        noSelect:"請先選擇需要分享的消息",
        shareInfo:"對話內容由 AI 自動生成，不代表官方的態度或觀點",
        goToChat:'進入雅意，發現更多內容',
        wordsCountTip:'超出字數限製，請基於前20萬字資料進行問答。',
        // linkInfo:"【雅意】這是我與{name}的聊天對話，你也來試試吧~【點擊鏈接直接打開 或者 復製內容至雅意APP直接打開】",
        // linkInfo2: "【雅意】這是我與AI搜索的聊天對話，你也來試試吧~【點擊鏈接直接打開 或者 復製內容至雅意APP直接打開】",
        // linkAgentInfo:"【雅意】這是我分享的智能體「{name}」，你也來試試吧~ 【點擊鏈接直接打開 或者 復製內容至雅意APP直接打開】",
        linkInfo:"【雅意】這是我與{name}的聊天對話，你也來試試吧~【點擊鏈接直接打開】",
        linkInfo2: "【雅意】這是我與AI搜索的聊天對話，你也來試試吧~【點擊鏈接直接打開】",
        linkInfo3: "【雅意】這是我生成的長文「{name}」，你也來試試吧~【點擊鏈接直接打開】",
        linkAgentInfo:"【雅意】這是我分享的智能體「{name}」，你也來試試吧~ 【點擊鏈接直接打開】",
        shareMessage:'掃碼下載雅意APP',
        pluginsResult:"暫無插件",
        linkText:'點擊鏈接查看和YAYI的對話',
        noData:"該會話暫時無法查看",
        chatIng:'當前對話正在進行中',
        uploadTitle:"文件拖拽到此即可上傳",
        uploadInfo:"支持上傳類型為：doc、docx、pdf、txt、md、jpg、jpeg、png",
        uploadInfo1:"支持上傳文件（最多10個文件，每個20MB）",
        uploadInfo2:"接受{name}格式",
        img:"圖片",
        uploadInfo3:"上傳的文件包含暫未支持的文件格式，請轉換文件格式後重試。支持的文件格式：{name}",
        loading:"上傳中",
        pluginInfo1:"已開啟插件，雅意會智能調用插件解決問題",
        pluginInfo2:"已關閉插件，問題將由雅意大模型直接回答",
        pluginInfo3:"上傳文件或網站後，已自動關閉插件",
        plugin:"插件",
        new:'最近',
        collect:'收藏',
        noCollect:"暫無收藏記錄",
        collectChat:"收藏這個對話",
        collected:"已收藏",
        noKnowList:"暫無知識庫",
        noKnowListInfo:"請先前往知識庫創建後添加",
        resultInfo:"已運行代碼解答",
        resultIng: "正在分析並生成代碼",
        outlineInfo:"已生成大綱",
        outlineIng: "正在生成大綱",
        deepthinkInfo:"已完成思考",
        deepthinkIng:"正在思考",
        deepthinkIng1:"正在生成...",
        result:"結果",
        searchWeb:'搜索網頁',
        bottomInfo:"內容由AI生成，僅供參考和借鑒",
        wenge:'中科闻歌',
        agentCenter:'智能體中心',
        linkInfo1:'訪問雅意開源社區',
        nameYayi:'雅意',
        like:'點贊',
        nolike:'點踩',
        preViewInfo:'暫不支持預覽',
        loadingPreViewInfo:'文件上傳中，不支持預覽',
        failPreViewInfo:'文件上傳失敗，不支持預覽',
        infoMessage:"（上傳超時，已截取部分內容）",
        aiSearchPlace:"全網資料、知識一鍵觸達",
        searchPlace:"請輸入問題...",
        from:'來自',
        share1:'的分享',
        chatAgain:'接著聊',
        deleteInfo:"該智能體已被刪除，無法進行對話",
        deleteInfo1: '該智能體已被發布者刪除，無法進行對話', 
        deleteInfo2: '該智能體已下線，無法進行對話',
        referenceSources: '參考來源',
        ask: '追問',
        writerInfo: '使用雅意writer專業AI寫作',
        editTheQuestion1: '您已經終止本次搜索，可',
        editTheQuestion2: '編輯問題',
        editTheQuestion3: '後重新發起。',
        stageSteps1: '問題剖析',
        stageSteps2: '資料檢索',
        stageSteps3: '答案總結',
        answerNodata1 : '您所選的來源未檢索到相關信息，可',
        answerNodata2 : '編輯問題',
        answerNodata3 : '或',
        answerNodata4 : '選擇其他來源',
        answerNodata5 : '後重新發起搜尋',
        resultTotal:'總結',
        textTruncation:'文件內容過長，已截取部分內容',
        tipName:'名稱不能為空',
        selectLabel:"請選擇舉報類型",
        historyPlace:'搜索對話標題...',
        historyPlace1:'搜索作品標題...',
         you:'你',
        clear:'清空',
        time:'時間：',
        noproductionInfo:'您還沒有生成過作品',
        noproductionInfo1:'期待您的精彩內容',
        name1:'長文寫作',
        resultInfo1:'生成的結果可以在',
        record:'記錄-作品',
        check:'中查看',
        longWrite:'長文',
        fail:'生成失敗',
        loadingInfo:'生成中',
        pendingInfo:"排隊中",
        editName:'重命名',
        public:'發布',
        checkHistory:"在對話中查看",
        noLink:'鏈接已失效',
        proDetail:'作品詳情',
        infoSend:'鏈接已失效，無法進行對話'






    },
    record: {
        record: '記錄',
        recordTip: '對話歷史記錄',
        assistant: '助手',
        assistantTip: '虛擬數位人播報',
        noMore: '暫無更多',
        confirm: '確認',
        deleteChat: '確認刪除此會話？ ',
        noChatRecord: '暫無對話記錄',
        yayiAssistant: 'YAYI助手',
        chatName: '對話名稱不能為空',
        startSound: '開啟聲音',
        closeSound: '關閉聲音',
        noChatRecord1: '沒有搜到哦，去問問雅意吧！',
        btn: '開啟新對話',
        loading:"數據加載中...",
        nodata:'您還沒有生成過作品',
        nodata1:'期待您的精彩內容',
        deleteChat1:'確認刪除此作品？'

    },
    prompt: {
        exit: '退出',
        cancel: '取消',
        confirmExit: '確認退出嗎？ ',
        exitTips: '退出後不儲存目前內容',
        createSkill: '新建指令',
        editSkill: '編輯指令',
        basicSkill: '基礎指令',
        skillName: '指令名稱',
        skillNamePlaceholder: '請輸入指令名稱',
        placeholder: '請輸入',
        placeholderSelect: '請選擇',
        category: '所屬分類',
        skillBrief: '指令簡介',
        templatePlaceholder: '請輸入範本內容',
        role: '背景角色',
        rolePlaceholder: '請輸入身份，如：金融專家，具備10年的行業經驗，是個資深的金融領域專家，具備金融領域實地分析和總結推理的能力，可以做金融、股市、媒體、互聯網等新興產業的 專業分析。 ',
        recommendedQuestions: 'Prompt',
        promptEmptyPlaceholder: '請輸入Prompt',
        promptPlaceholder: "請輸入模版內容，插值參數透過大括號{'{}'}中填入定義，支援英文、數字、底線，且不能是純數字，長度2-30。範例：文章內容：{'{' } article{'}'} ，請以{'{'}number{'}'}字數來總結",
        variable: '變數',
        variablePlaceholder: '請輸入變數範例值',
        noData: '暫無資料',
        creativity: '創造力',
        save: '儲存',
        debug: '調試',
        promptPreview: 'Prompt 預覽',
        promptPreviewTip: '左側輸入Prompt即可即時預覽',
        run: '運行',
        result: '結果',
        time: '耗時',
        takeToken: '花費Token',
        generateResult: '結果生成...',
        variableName: '變數名稱',
        type: '類型',
        example: '範例',
        string: '字串',
        newSkills: "創建指令",
        editSkills: "編輯指令",
        examples: "應用範例Prompt",
        skillNameFirstTip: "請先輸入指令名稱",
    },
    store: {
        bgRoleName: '雅意',
        // errorText: '網絡開小差去了，請稍後再戳戳我',
        errorText: '很抱歉，服務太火爆了，請您稍後試試吧！ ',
        errorText1: '網路連線似乎有點問題，檢查您的網路設定後再次嘗試。',
        errorText2: '目前服務負載較高，請稍後試試。',
        stopGenerate: '停止生成',
        loginInvalidation: '該裝置登入已失效',
        loginAgainContent: '請重新登入',
        loginAgainBtn: '重新登入',
        caiFormTitle: '您的回饋對我們意義重大，您認為',
        caiFormPlaceholder: '您認為更理想的答案是什麼？ ',
        zanFormTitle: '您的回饋對我們意義重大，您認為',
        zanFormPlaceholder: '帶給您的驚喜有哪些？ ',
        report:'舉報',
        type:'舉報問題類型',
        desc:'問題描述',
        placeHold:'請輸入內容'





    },
    temperature: {
        title: '創造力是指模型在產生答案時的「溫度（temperature）」參數。 這個參數可以影響大模型的回答自由度。 ',
        lowTitle: '創造力較低時',
        lowDescribe: '模型會更加謹慎，避免產生過於激進或冒險的答案。 ',
        hightTitle: '創造力較高時',
        hightDescribe: '模型會更開放，敢於嘗試新的、不尋常的答案。 ',
        temperatureType1: '嚴謹',
        temperatureType2: '均衡',
        temperatureType3: '創意'
    },
    role: {
        edit: '編輯',
        delete: '刪除',
        add: '新增',
        deleteCancel: '取消',
        cancel: "取消",
        neverCrate: "您還未建立過指令",
        createImmediate: '立即建立',
        debug: '調試',
        variableName: '變數名稱',
        string: '字串',
        type: '類型',
        example: '範例',
        default: '默認值',
        save: '儲存',
        confirmExit: '確認退出嗎？ ',
        exitTips: '退出後不儲存目前內容',
        exit: '退出',
        createAssistant: "創建智能體",
        roleAssistant: "智能體",
        roleAssistantDes: "你可以透過創建智能體的方式創建領域專家助手，設定對話智能體的身份信息，比如智能體專業度、回答風格、詢問策略等關鍵信息，使其具備快速學習和適應新智能體的能力， 提供全面且專業的服務。",
        skillAssistant: "指令",
        skillAssistantDes: "你可以透過創建指令的方式設定大模型的回應邊界、標準、要求等條件，確保大模型輸出的答案效果可控，基於大模型生成能力雅意可以提供文章摘要生成、翻譯、抽取、 多模態內容理解與產生的指令服務。",
        exitAssistant: "退出智能體",
        helloRole: "你好，我係",
        deleteDes: "若刪除此智能體，與之相關的對話記錄都會被刪除，且不可恢復。",
        createRoleAssistant: "创建智能體",
        EditRoleAssistant: "編輯智能體",
        avatar: "頭像",
        roleName: "名稱",
        entryRoleName: "請輸入智能體名稱",
        placeholderRoleName: "面試官、法律專家",
        roleNameTip: "設定的智能體暱稱",
        roleDesc: "簡介",
        entryRoleDesc: "請輸入智能體簡介",
        placeholderRoleDesc: "我是你的媒體助理小明，可以幫你撰寫即時資訊等新聞稿件，24小時為你服務",
        roleDescTip: "描述該智能體的介紹話術",
        AIRecommend: "AI生成推薦",
        openingRemarks: "開場白",
        entryOpeningRemarks: "請輸入對話開場白",
        placeholderOpeningRemarks: "你好，我是你的客服FAQ助手，你可以這樣問我",
        openingRemarksTip: "開啟智能體對話視窗時，智能體的第一句",
        systemPreset: "身份設定",
        entrySystemPreset: "請輸入身份設定",
        placeholderSystemPreset: "你是一個專業的面試官，人類是你的候選人，人類會發送需要面試的職位名稱，然後你會根據崗位，與人類通過多輪問答的形式展開面試。\n要求：\n1 . 你與候選人需要用中文交流；\n2. 你每次只需要向面試者提問一個問題；\n3. 當你與候選人問答六個輪次後（即候選人回答完第6個問題後 ）面試結束，你需要根據候選人的回答情況給予面試評價。",
        systemPresetTip: "設定身份資訊後，系統會依照設定的身份快速學習並適應新智能體。系統智能體身份描述越精準，智能體越專業",
        questionItemExp: "提問範例",
        questionItemExpTip: "設定智能體後，助手的推薦問題",
        expTitle: "範例標題",
        PromptRecommend: "Prompt推薦",
        input:"請輸入", // input:"Please enter",
        promptPlaceholder: "請輸入模版內容，插值參數透過大括號{'{}'}中填入定義，支援英文、數字、底線，且不能是純數字，長度2-30。範例：文章內容：{'{' } article{'}'} ，請以{'{'}number{'}'}字數來總結",
        plugins: "預設插件",
        debugTitle: "調試與預覽",
        debugTip: "完善左側的智能體基本資訊後，即可執行偵錯",
        expQuestion: "範例問題",
        examplePrompt: "範例Prompt",
        addMsg:"新增成功",
        editMsg:"編輯成功",
        edmitMsg:"提交失敗",
        configDelete: "確認刪除智能體",
        configRemove: "確認移除智能體",
        talk:"你可以跟我對話了~",
        searchPlaceholder: "搜尋關鍵字",
        pluginsTip: "雅意大模型會基於你的問題判斷需要調用庫中的哪個插件回答。",
        presetOne: "範例一",
        presetTwo: "範例二",
        presetThree: "範例三",
        enterName:"請先輸入智能體名稱",
        enterIntroduction:"請先輸入智能體名稱及智能體簡介",
        completeSample: "請輸入完整预置內容後再新增",
        promptList: '指令中心',
        agentAll:'公開',
        agentHot:'熱門',
        agentMy:'我的',
        agentName: '智能體',
        infoMessage:"存在上傳中或解析中的文件請稍後再試！",
        linkInfo:'鏈接重復！',
        fileInfo:"文件重復！",
        infoWords:"簡介限製500個字",
        pluginsInfo:"請選擇插件",
        lineCheck:'聯網查詢：',
        ready:'問題深度剖析中',
        running:'問題剖析完畢，檢索中',
        finish:'正在讀取網頁總結中',
        arrow1:"展開",
        arrow2:"收起",
        null:"不能為空",
        refreshInfo:"刷新調試",
        select:'{name}已添加',
        noselect: '{name}已删除',
        chat: '雅意',
        serach:'AI搜尋',
        file: '知識庫',
        uie: '知識抽取',
        placeholder:"请输入示例值",
        write:'AI寫作',
        kyzs: '科研助手',
        publicInfo:"發布雅意智能體",
        publicInfo1:'無需登錄，打開即用——開放式智能體快捷方式',
        ignore:'下次不再提示',
        create:"創建發布鏈接",
        info:'已復製發布鏈接，可前往',
        info1:'個人中心>發布管理',
        info2:'中管理發布記錄',
    },
    recharge:{
        fees: '帳戶餘額欠費',
        noiceTitle: '帳戶餘額提示',
        noiceTip: '為不影響您的正常使用，建議您先儲值帳戶。 ',
        later: '稍後再說',
        goRecharge:'去充值',
        insufficientBalance: '餘額不足',
        message1: '該次服務呼叫扣費',
        message2: '您帳戶目前剩餘',
    },
    addRole:{
        limitUpload:"最多添加三個預置問題",
        select:"頭像選擇",
        model:"模型",
        file:'知識文件',
        upload:"上傳文件",
        info:"支持文件類型：.doc .docx .pdf .txt Markdown...最多十個",
        about:'約',
        text:"字",
        desc:'一句話描述你的智能體',
        desc1:'極速模式',
        placehold:'請輸入描述語',
        desText:'描述',
        add:'生成智能體配置',
        addUrl:"添加URL",
        limit:'限製10個',
        address:'URL地址',
        cancel:"取消",
        confrim:"確定",
        exapmle:'作為一個輿情分析師，可以通過用戶提供的熱點資訊，分析該熱點資訊產生的市場效應，並總結概述、分析事情產生的原因、事件產生的結果，若有參與人也請一並列出。',
        info1:'請輸入URl',
        info2:'最多上傳10個文件',
        info3:'最多上傳10個Url',
        status1:'上傳中...',
        status2:'解析中...',
        status3:'失敗',
        intell:"智能體",
        all:"全部",
        hot:'熱門',
        my:'我的',
        technologySet:"問例配置",
        kowledge:'知識庫配置',
        base:'基礎配置',
        setting:'插件配置',
        modelSetting:'模型配置',
        modelSelect:'模型選擇',
        parSet:'參數設置',
        addExample:"添加示例",
        uploadUrl:'添加URL',
        uploadKnowledge:'關聯知識庫',
        selected:'已選擇',
        selectedName:'個文件',
        placeHolder:"關鍵詞搜索",
        answerModel:"回答模式",
        v2:'智能模式',
        v3:'高級搜索',
        vInfo:'不選擇任何插件時僅能通過雅意大模型直接回答問題',
        v2Info:'基於問題判斷需要調用的插件回答',
        v3Info:'將問題拆解為相互關聯的子問題，再進行聯網檢索',
        selctPlugin:"插件",
        creatSet:"創造力",
        infoSubmit:'請先完善基礎配置',
        pluginInfo1:"接入互聯網檢索信息",
        pluginInfo2:"借助計算器進行數學運算",
        pluginInfo3:"支持未來7天（含當日）天氣查詢",
        pluginInfo4:"根據網絡熱度獲取指定主題最新熱點信息",
        pluginInfo5:"借助生成和執行代碼獲取數學運算、圖表繪製、Md表格問答等精確結果",
        pluginInfo6:"分步驟生成大綱和萬字長文",
        gotoFile:"前往知識庫",
        modelTitle:"高級搜索不支持掛載知識庫",
        modelInfo:"繼續切換模式已選知識庫將失效",
        modelInfo1:'您也可以在"智能模式下勾選"聯網"插件，以實現智能體的聯網功能',
        continue:"繼續",
        edit:"編輯",
        remove:'移除',
        auxiliary:'輔助功能',
        open:'啟用',
        close:'禁用',
        baseInfo:'基礎信息',
        appendFun:"擴展功能",
        redAnaly:'文件閱讀分析',
        readTitle:'文件閱讀分析操作指南',
        readInfo:'解讀用戶發送的文件內容回答問題',
        fileType:'支持文件格式',
        webAnaly:'網頁閱讀分析',
        webTitle:'網頁閱讀分析操作指南',
        webInfo:'解析用戶發送的網頁鏈接內容回答問題',
        preQuestion:'預置問題',
        addQuestion:'添加問題',
        questionTitle:"問題名稱",
        questionTitleInfo:'不填寫時按鈕將直接展示問題內容',
        questionCintentInfo:"可通過輸入“{'{}'}”在問題中添加變量，如：“{'{'}內容{'}'}”",
        placeHold1:'進入智能體顯示的預置問題按鈕名稱',
        placeHold2:'想要發送的信息內容',
        content:"問題內容",
        name:'文件名',
        state:'上傳狀態',
        size:'上傳大小',
        operation:'操作',
        valid:'變量',
        confirm:"確定",
        infoValid:'變量默認值不能為空',
        infoError:'請先刪除異常文件',
        infoLimit:'字數超出限製，請刪減內容',
        crate:'創建預置問題',
        editQ:'編輯預置問題',
        nodata:"暫無分享智能體",
        share:"分享給我",
        infoUpload:'上傳文件後智能體將支持輸入問題時上傳對應格式的文件',
        infoSwitch:"预置问题中包含已上传文預置問題中包含已上傳文件，不可禁用件",
        selectDisInfo:"預置問題中已上傳該格式文件，不可取消勾選",
        deleteInfo:'刪除後所有用戶將無法繼續與該智能體對話，已經產生的對話記錄不受影響。',
        uploadSuccess:'上傳成功',
        type:'知識庫類型',
        modelTitle1:"确认切换知识库类型吗？",
        modelInfo2:'繼續切換知識庫類型已選知識庫將失效',
        uploadText:'拖動到此，上傳文件',
        loading:'正在生成配置... （{time}s）'


    },
    search:{
        yayi:"雅意",
        search:"搜尋",
        change:'換一批',
        hot:'今日熱點',
        recommend:'推薦',
        origin:'來源',
        sendTitle:"請輸入問題再發送",
        webOrigin:'網絡信源類型',
        web:'網絡',
        file:'知識庫',
        info:'請輸入內容',
        select:'至少選擇一個類型',
        selectInfo:'請至少選擇一個網絡來源',
        webInfo:'請選擇網絡來源',
        webAll:'全網',
        originSelect:"指定來源",
        webAllInfo:"搜索全網資料獲取答案",
        originInfo:'請至少選擇一個來源',
        guess:'猜你想搜'

    },
    longText:{
        loadMessage:'請稍候片刻，精彩即將呈現...',
        loading:'AI生成',
        success:'生成成功，可前往',
        link:'記錄>作品',
        check:'查看',
        fail:'作品生成失敗',
        fail1:'好像遇到一些問題，請等一會兒再試吧~',


    },
    share:{
        longWrite:'長文',
        totalWords:'總字數：{total}',
        web:"網頁版"


    }
}